export const ocppLogs = {
  title: 'OCPP Logs',
  pageTitle: 'OCPP Logs Query',
  subtitle: 'Search and analyze OCPP protocol logs across all chargers',
  filters: {
    title: 'Search Filters',
    ocppServer: 'OCPP Server',
    ocppServerPlaceholder: 'Search for an OCPP server...',
    ocppServerRequired: 'OCPP Server *',
    charger: 'Charger',
    chargerPlaceholder: 'Search for a charger...',
    chargerHelper: 'Leave empty to search all chargers',
    dateRange: 'Date Range',
    startDateTime: 'Start Date & Time',
    endDateTime: 'End Date & Time',
    actionType: 'Action Type',
    direction: 'Direction',
    logLevel: 'Log Level',
  },
  dateRanges: {
    last1Hour: 'Last 1 Hour',
    last24Hours: 'Last 24 Hours',
    today: 'Today',
    customRange: 'Custom Range',
  },
  actions: {
    allActions: 'All Actions',
    startTransaction: 'StartTransaction',
    stopTransaction: 'StopTransaction',
    meterValues: 'MeterValues',
    statusNotification: 'StatusNotification',
    authorize: 'Authorize',
    heartbeat: 'Heartbeat',
    bootNotification: 'BootNotification',
    remoteStartTransaction: 'RemoteStartTransaction',
    remoteStopTransaction: 'RemoteStopTransaction',
  },
  directions: {
    allDirections: 'All Directions',
    incoming: 'Incoming (Charger → OCPP Server)',
    outgoing: 'Outgoing (OCPP Server → Charger)',
  },
  levels: {
    allLevels: 'All Levels',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    debug: 'Debug',
  },
  buttons: {
    searchLogs: 'Search Logs',
    refresh: 'Refresh with current filters',
  },
  messages: {
    serverSelected: 'Server selected. You can now search OCPP logs.',
    selectServer: 'Please select an OCPP server to begin searching logs',
    noLogsFound: 'No logs found. Try adjusting your search filters or date range.',
    loadingServers: 'Loading servers...',
    loadingChargers: 'Loading chargers...',
    noServersFound: 'No OCPP servers found',
    noChargersFound: 'No chargers found for this server',
    selectServerFirst: 'Select a server first',
    loading: 'Loading...',
  },
  results: {
    title: 'Search Results',
    showing: 'Showing %{count} of %{total} log entries',
  },
  logEntry: {
    timestamp: 'Timestamp',
    ocppAction: 'OCPP Action',
    direction: 'Direction',
    fullLogData: 'Full Log Data',
  },
  badges: {
    incoming: 'Incoming (Charger → OCPP Server)',
    outgoing: 'Outgoing (OCPP Server → Charger)',
  },
};
